import { render } from "./CartIndex.vue?vue&type=template&id=89ef7958"
import script from "./CartIndex.vue?vue&type=script&lang=js"
export * from "./CartIndex.vue?vue&type=script&lang=js"

import "./CartIndex.vue?vue&type=style&index=0&id=89ef7958&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__